module.exports = __webpack_public_path__ + "img/w2.7425bda0.png";